import React from "react";
import { IIcons } from "./icons";

const Telegram = ({ fillColor }: IIcons.IconProps) => (
  <svg
    width="32"
    height="32"
    className={fillColor}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="16" fill="#14B1E7" />
    <path
      d="M8 12.9106L12.0188 17.421L18.9703 13.6069L14.3829 20.0742L18.4017 24.5845L23.2013 9.83702L8 12.9106Z"
      fill="white"
    />
  </svg>
);
export default Telegram;
